import { render, staticRenderFns } from "./ShopOrderList.vue?vue&type=template&id=31928ef2&scoped=true"
import script from "./ShopOrderList.vue?vue&type=script&lang=js"
export * from "./ShopOrderList.vue?vue&type=script&lang=js"
import style0 from "./ShopOrderList.vue?vue&type=style&index=0&id=31928ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31928ef2",
  null
  
)

export default component.exports